import React from "react";
import { useTranslation } from "react-i18next";
import { Building2, Handshake, Network, ShieldCheck } from "lucide-react";
import hero from "../../images/Home_Public_339ea30a2c.jpg";

const cardStyle = {
  backgroundColor: "#fff",
  borderRadius: 12,
  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
};

const chipStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  border: "1px solid #d7efe7",
  padding: "10px 16px",
  borderRadius: 30,
  background: "#ffffff",
  color: "#007a56",
  fontWeight: 600,
};

const BenefitsSection = () => {
  const { t } = useTranslation();

  const bullets = [
    t("EmiratesMade.Benefits.1", { defaultValue: "Official use of the Made in the Emirates label." }),
    t("EmiratesMade.Benefits.2", { defaultValue: "Inclusion in government‑backed promotional campaigns and trade missions." }),
    t("EmiratesMade.Benefits.3", { defaultValue: "Access to networking with investors and global partners." }),
  ];

  const highlights = [
    { icon: Network, title: t("EmiratesMade.Benefits.cards.network", { defaultValue: "Global Connections" }) },
    { icon: Building2, title: t("EmiratesMade.Benefits.cards.infrastructure", { defaultValue: "Advanced Infrastructure" }) },
    { icon: Handshake, title: t("EmiratesMade.Benefits.cards.partnerships", { defaultValue: "Government Partnerships" }) },
    { icon: ShieldCheck, title: t("EmiratesMade.Benefits.cards.policies", { defaultValue: "Pro‑Business Policies" }) },
  ];

  return (
    <section id="benefits" style={{ padding: "80px 10%", backgroundColor: "#fff" }}>
      {/* Top split like the reference: image left, copy right */}
      <div style={{ ...cardStyle, overflow: "hidden", marginBottom: 30 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr" }}>
          {/* Left image */}
          <div style={{ minHeight: 360 }}>
            <img src={hero} alt="Business in the UAE" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
          {/* Right copy */}
          <div style={{ padding: "40px 48px", background: "linear-gradient(180deg,#f7fbf9 0%,#ffffff 80%)" }}>
            <h2 style={{ fontSize: 28, lineHeight: 1.3, color: "#0a2750", fontWeight: 800, margin: 0 }}>
              {t("EmiratesMade.Benefits.hero.title", { defaultValue: "The UAE offers a thriving business environment with unmatched advantages for investors." })}
            </h2>
            <p style={{ marginTop: 14, color: "#4b5563", lineHeight: 1.8 }}>
              {t("EmiratesMade.Benefits.hero.text", { defaultValue: "Investing in the UAE means benefiting from a strong economy, supportive policies, and joining a nation with a clear vision for the future." })}
            </p>

            <ul style={{ marginTop: 10, paddingLeft: 18, color: "#374151", lineHeight: 1.7 }}>
              {bullets.map((b, i) => (
                <li key={i} style={{ marginBottom: 6 }}>{b}</li>
              ))}
            </ul>

            <a
              href="#contact"
              style={{
                display: "inline-block",
                marginTop: 20,
                backgroundColor: "var(--uae-red)",
                color: "#fff",
                fontWeight: 700,
                textDecoration: "none",
                padding: "12px 28px",
                borderRadius: 10,
              }}
            >
              {t("EmiratesMade.Benefits.cta", { defaultValue: "Ask About Sponsorship" })}
            </a>
          </div>
        </div>
      </div>

      {/* Responsive styles for highlights grid */}
      <style>{`
        .benefits-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:20px}
        @media(max-width:1100px){.benefits-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}
        @media(max-width:800px){.benefits-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
        @media(max-width:560px){.benefits-grid{grid-template-columns:1fr}}
      `}</style>

      {/* Bottom highlight cards (3–4) */}
      <div className="benefits-grid">
        {highlights.map((h, i) => {
          const Icon = h.icon;
          return (
            <div key={i} style={{ ...cardStyle, padding: 24, background: "#f4f7f6" }}>
              <div style={{ textAlign: "center", marginBottom: 10 }}>
                <Icon size={42} color="#0a2750" />
              </div>
              <h3 style={{ textAlign: "center", color: "#0a2750", fontWeight: 800, fontSize: 18, margin: 0 }}>{h.title}</h3>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default BenefitsSection;
